import type { ClaimReceiptAmount } from 'all-in-one-shared-api';
import { ClaimRemark } from 'all-in-one-shared-api';
import { Alert as AntdAlert, Result, Space, Typography } from 'antd';
import ClaimSubmitSuccess from 'assets/images/newClaim/claim-submit-success.svg';
import { PrimaryButton } from 'components/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const { Paragraph } = Typography;

const Alert = styled(AntdAlert)`
  .ant-alert-content {
    text-align: initial;
  }
`;

const InfoAlert = styled(Alert)`
  background-color: var(--info-background-color);
  border: 1px solid var(--info-border-color);
  > .ant-alert-icon {
    color: var(--info-color);
  }
`;

interface SubmitSuccessPageProps {
  referenceNo?: string;
  remark?: ClaimRemark;
  receiptWaiverAmount?: ClaimReceiptAmount;
  mainTitleKey?: string;
}

const SubmitSuccessPage = ({
  referenceNo,
  remark,
  receiptWaiverAmount,
  mainTitleKey = 'newClaim.claimSuccess.createdClaim',
}: SubmitSuccessPageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!referenceNo) {
    navigate('/home', { replace: true });
  }

  return (
    <Result
      icon={<img src={ClaimSubmitSuccess} />}
      title={t(mainTitleKey)}
      subTitle={t('newClaim.claimSuccess.reference', { referenceNumber: referenceNo })}
      extra={
        <Space direction="vertical" size="middle" style={{ width: '30.5rem' }}>
          <Paragraph>
            {t('newClaim.claimSuccess.contactCustomerService')} {t('newClaim.claimSuccess.consultTeladoc')}
          </Paragraph>
          {remark === 'POLICY_RENEWAL_IN_PROGRESS' && (
            <Alert
              showIcon
              type="warning"
              message={t('newClaim.claimSuccess.processLater')}
              description={t('newClaim.claimSuccess.processLaterDescription')}
            />
          )}
          {receiptWaiverAmount && (
            <Alert
              showIcon
              type="warning"
              message={t('newClaim.claimSuccess.submitReceipts')}
              description={t('newClaim.claimSuccess.overAmount', {
                amount: receiptWaiverAmount.amount,
              })}
            />
          )}
          <InfoAlert
            showIcon
            message={t('newClaim.claimSuccess.keepYourReceipts')}
            description={t('newClaim.claimSuccess.keepYourReceiptsDescription')}
          />
          <PrimaryButton onClick={() => navigate('/claims')}>{t('newClaim.claimSuccess.goToMyClaims')}</PrimaryButton>
        </Space>
      }
    />
  );
};

export default SubmitSuccessPage;
